import { useMemo } from 'react';
import {
  PolicyShieldsRuleOutcomeType,
  useChecklistContext,
} from '../../../../../../contexts';
import { ChecklistSection } from '../../../../ChecklistPage';
import { GenericSection } from '../../../GenericSection';
import { RuleOutcomeItem } from '../../components/RuleOutcomeItem';

export type RuleOutcomeSectionProps = {
  ruleOutcomeType: PolicyShieldsRuleOutcomeType,
  subSection: ChecklistSection.POLICY_SHIELDS_REFERRALS | ChecklistSection.POLICY_SHIELDS_REJECTIONS,
}

export default function RuleOutcomeSection({ ruleOutcomeType, subSection }: RuleOutcomeSectionProps) {
  const { checklist } = useChecklistContext();

  const {
    policyShields,
  } = checklist ?? {};

  const ruleOutcomeIndices = useMemo(() => policyShields?.ruleOutcomes?.reduce((prev, current, index) => ({
    ...prev,
    [current.id]: index,
  }), {} as Record<string, number>), [checklist]);

  const ruleOutcomesByType = policyShields?.ruleOutcomes?.filter((ro) => ro.outcome === ruleOutcomeType) ?? [];

  if (!ruleOutcomesByType.length) return <></>;

  return (
    <GenericSection
      id={ruleOutcomeType}
      subSection={subSection}
      level={1}
    >
      {
        ruleOutcomesByType?.map((ro) => (<RuleOutcomeItem key={ro.id} index={ruleOutcomeIndices?.[ro.id]} ruleOutcome={ro} />))
      }
    </GenericSection>
  );
}
